import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { PersonalizationProfileDialog } from '@client/components/listingForm/PersonalizationProfileDialog';
import { ProfileSelect } from '@client/components/listingForm/ProfileSelect';
import { useApiClient } from '@client/hooks/useApiClient';
import { toastError } from '@client/toaster';
import { callApi } from '@client/utils/apiUtils';
import { useState } from 'react';
export const PersonalizationProfileSelect = ({ shopShortId, profiles, onAddProfile, value, onChange, disabled, }) => {
    const apiClient = useApiClient();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [saving, setSaving] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsx(ProfileSelect, { items: profiles.map((p) => ({
                    value: String(p.id),
                    label: p.name,
                })), value: value, onChange: onChange, onClickAdd: () => setDialogOpen(true), disabled: disabled }), _jsx(PersonalizationProfileDialog, { open: dialogOpen, onClose: () => setDialogOpen(false), existingNames: profiles.map((p) => p.name), saving: saving, onConfirm: async (p) => {
                    setSaving(true);
                    const result = await callApi(apiClient.shopManager.createPersonalizationProfile({
                        params: { shopId: shopShortId },
                        body: {
                            name: p.name,
                            costCents: p.costCents,
                            helperText: p.helperText,
                        },
                    }));
                    setSaving(false);
                    if (result.error !== null) {
                        toastError('Failed to create personalization profile.');
                        return;
                    }
                    const profile = {
                        id: String(result.data.id),
                        name: result.data.name,
                        costCents: result.data.costCents,
                        helperText: result.data.helperText,
                    };
                    onAddProfile(profile);
                    onChange(profile.id);
                    setDialogOpen(false);
                } })] }));
};
